import { render } from "./CartaoCompra.vue?vue&type=template&id=0eba8754&scoped=true"
import script from "./CartaoCompra.vue?vue&type=script&lang=js"
export * from "./CartaoCompra.vue?vue&type=script&lang=js"

import "./CartaoCompra.vue?vue&type=style&index=0&id=0eba8754&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eba8754"]])

export default __exports__